(function () {
  var selector = '.jf-blog-product[data-product-handle]';
  var cache = {};

  function validHandle(handle) {
    return /^[a-z0-9][a-z0-9-]*$/i.test(handle);
  }

  function sectionUrl(handle) {
    var root =
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '/';

    return (
      root +
      'products/' +
      encodeURIComponent(handle) +
      '?section_id=jf-blog-product-card'
    );
  }

  function getCardHtml(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(sectionUrl(handle), {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Product card request failed');
        }

        return response.text();
      });
    }

    return cache[handle];
  }

  function loadCard(slot) {
    if (slot.dataset.jfState) return;

    var handle = (slot.dataset.productHandle || '').trim();

    if (!validHandle(handle)) {
      slot.dataset.jfState = 'error';
      return;
    }

    slot.dataset.jfState = 'loading';
    slot.setAttribute('aria-busy', 'true');

    getCardHtml(handle)
      .then(function (html) {
        var template = document.createElement('template');
        template.innerHTML = html.trim();

        var card = template.content.querySelector('.jf-blog-card');

        if (!card) {
          throw new Error('Product card markup missing');
        }

        slot.replaceChildren(card.cloneNode(true));
        slot.dataset.jfState = 'loaded';
        slot.removeAttribute('aria-busy');
      })
      .catch(function () {
        slot.dataset.jfState = 'error';
        slot.removeAttribute('aria-busy');
      });
  }

  function init() {
    var slots = document.querySelectorAll(selector);

    if (!slots.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            observer.unobserve(entry.target);
            loadCard(entry.target);
          });
        },
        {
          rootMargin: '400px 0px'
        }
      );

      slots.forEach(function (slot) {
        observer.observe(slot);
      });
    } else {
      slots.forEach(loadCard);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();